class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.observeVisibility();
    this.observePrice();
    this.bindBuyNow();
  }

  observeVisibility() {
    const target =
      document.querySelector(`#ProductSubmitButton-${this.sectionId}`) ||
      document.querySelector(`#ProductInfo-${this.sectionId}`);

    if (!target || !('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(target);
  }

  observePrice() {
    const mainPrice = document.getElementById(`price-${this.sectionId}`);
    const stickyPrice = this.querySelector(`#StickyPrice-${this.sectionId}`);
    if (!mainPrice || !stickyPrice) return;

    stickyPrice.innerHTML = mainPrice.innerHTML;

    const observer = new MutationObserver(() => {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    });
    observer.observe(mainPrice, { childList: true, subtree: true, characterData: true });
  }

  bindBuyNow() {
    const buyNowButton = this.querySelector(`#StickyBuyNow-${this.sectionId}`);
    if (!buyNowButton) return;

    buyNowButton.addEventListener('click', () => {
      const form = document.getElementById(`product-form-${this.sectionId}`);
      if (!form) return;

      const formData = new FormData(form);
      buyNowButton.setAttribute('aria-busy', 'true');
      buyNowButton.disabled = true;

      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(() => {
          window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
        })
        .catch(() => {
          buyNowButton.removeAttribute('aria-busy');
          buyNowButton.disabled = false;
          form.requestSubmit();
        });
    });
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);